<template>
  <div>
    <v-container class="py-10">
      <v-row class="align-center">
        <v-col cols="12" lg="6" class="pr-10">
          <h2>13. Zukunftstechnologien</h2>
          <p>
            Hinweis: Ich habe jetzt das "kann nicht eingeschätzt werden" auf die
            Linke Seite gepackt.
          </p>
          <p style="color: green">
            <b>UPDATE</b>
          </p>
        </v-col>
        <v-col cols="12" lg="6">
          <highcharts :options="chartOptions" ref="chart"></highcharts>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "FutureTechnologies",
  computed: {
    chartOptions() {
      return {
        chart: {
          type: "bar"
        },
        title: {
          text:
            "Wie schätzen Sie das Potenzial dieser neuen Technologien für Ihre Organisation ein?"
        },
        colors: ["#005a85", "#0391af", "#444"],

        xAxis: {
          categories: [
            "Blockchain",
            "Künstliche Intelligenz",
            "Chatbots",
            "3D Druck",
            "Internet of Things",
            "Cloud Computing",
            "Virtual Reality"
          ],
          crosshair: true
        },
        yAxis: {
          min: 0,
          max: 100,
          title: {
            text: "Prozent der Organisationen"
          }
        },
        tooltip: {
          headerFormat:
            '<span style="font-size:10px">{point.key}</span><table>',
          pointFormat:
            '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            '<td style="padding:0"><b>{point.y:.1f}%</b></td></tr>',
          footerFormat: "</table>",
          shared: true,
          useHTML: true
        },
        plotOptions: {
          series: {
            stacking: "normal"
          }
        },
        legend: {
          reversed: true
        },
        series: [
          {
            name: "Großes oder sehr großes Potenzial",
            data: [4.06, 12.07, 7.47, 11.19, 10.81, 40.47, 14.75]
          },
          {
            name: "Kein oder mäßiges Potenzial",
            data: [61.83, 77.7, 80.16, 82.27, 64.87, 49.52, 70.22]
          },
          {
            name: "Kann nicht eingeschätzt werden",
            data: [34.11, 10.23, 12.37, 6.53, 24.32, 10.01, 15.03]
          }
        ],
        exporting: {
          enabled: true,
          fallbackToExportServer: false
        }
      };
    }
  },
  methods: {
    downloadJPEG() {
      this.$refs.chart.chart.exportChart({ type: "image/jpeg" });
    },
    downloadSVG() {
      this.$refs.chart.chart.exportChart({ type: "image/svg+xml" });
    },
    downloadPDF() {
      this.$refs.chart.chart.exportChart({ type: "application/pdf" });
    },
    downloadCSV() {
      this.$refs.chart.chart.downloadCSV();
    }
  }
};
</script>

<style scoped>
.chapter-color {
  background-color: #fff;
  min-height: 20em;
}
.component-color {
  background-color: #fff;
}
</style>
